import FlexibleTemplate from "./FlexibleTemplate";

export default FlexibleTemplate;
